// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__12xR-","addWidgetButton":"Header_addWidgetButton__jyNPg","dashboardTabs":"Header_dashboardTabs__XirGD","active":"Header_active__QwSI9"};